import { BsBellFill, BsPencil, BsTrash } from "react-icons/bs"
import { FunctionComponent, h } from "preact"

import { Button } from "../../../parts/buttons"
import Container from "../../../parts/container"
import EditUser from "./edit-user"
import NewUser from "./new-user"
import TopBar from "../../../components/topbar"
import { User } from "../../../types/user"
import UserRoles from "./user-roles"
import { mutate } from "swr"
import useAuth from "../../../hooks/useAuth"
import { useConfirm } from "../../../context/useConfirm"
import useModal from "../../../hooks/useModal"
import { useState } from "preact/hooks"
import useUsers from "../../../hooks/useUsers"
import useMills from "../../../hooks/useMills"
import useCems from "../../../hooks/useCems"
import useObjectState from "../../../hooks/useObjectState"
import useAllCompany from "../../../hooks/useAllCompany"


type AdminUserPageProps = h.JSX.HTMLAttributes<HTMLDivElement>

const AdminUserPage: FunctionComponent<AdminUserPageProps> = () => {
  const { data: users } = useUsers()
  // console.log(users)
  const { fetcher } = useAuth()
  const [edited, setEdited] = useState<User>()

  const [filter, setFilter] = useObjectState({
    mil: "",
    cems: "",
    sensor: "",
    company:"",
    userku:[]
  })
  const { data: mills } = useMills()
  const { data: companies } = useAllCompany()

  
  const usersi = users?.filter(({ company }) => company?.uuid == filter.company || !filter.company)
  // console.log(users)
  // console.log(companies)

  const { show: showNewUser, onHide: hideNewUser, onShow: onShowNewUser } = useModal()
  const { show: showEditUser, onHide: hideEditUser, onShow: onShowEditUser } = useModal()
  const { show, onHide, onShow } = useModal()

  const confirmation = useConfirm()
  const handleDelete = (user: User) => () => {
    const msg = <div>Are you sure you want to delete it?</div>
    confirmation(
      msg,
      () => {
        const url = "/user/" + user.uuid
        fetcher()
          .delete(url)
          .then(() => {
            mutate("/user")
          })
          .catch(console.error)
      },
      { yes: "Delete", no: "Cancel" }
    )
  }

  if (!users) return <div>Loading...</div>
  return (
    <div className="min-vh-100"> 
      <TopBar title="SPARING" subtitle="User">
      <select
          className="w-auto form-select rounded-pill"
          onChange={({ currentTarget }) => setFilter({ company: currentTarget.value, cems: "", sensor: "" })}
          value={filter.company}
        >
          <option value="">All Affiliate	</option>
          {companies?.map((company) => (
            <option key={company.uuid} value={company.uuid}>
              {company.name}
            </option>
          ))}
        </select>
      </TopBar>
      <Container>
        <div className="card">
          <div className="card-title">
            <h3>User</h3>
            <div className="d-flex">
              <Button className="ms-2" onClick={onShowNewUser} variant="primary">
                ADD NEW USER
              </Button>
              <Button className="ms-2" onClick={onShow} variant="primary">
                SEE ROLES DESCRIPTION
              </Button>
            </div>
          </div>
          {/* {usersi} */}
          <div className="card-body">
            <table className="table table-striped">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Role</th>
                  <th>Affiliate</th>
                  <th>Notification</th>
                  <th>Menu</th>
                </tr>
              </thead>
              <tbody>
                {usersi?.map((user, idx) => (
                  <tr key={"user-" + idx}>
                    <td>{user.name}</td>
                    <td>{user.email}</td>
                    <td>{user.role}</td>
                    <td>{user.company?.name || "HQ"}</td>
                    <td className="text-center">
                      <Button icon={BsBellFill} variant="primary" disabled={!user.notification} />
                    </td>
                    <td className="text-center">
                      <Button
                        className="me-2"
                        variant="secondary"
                        icon={BsPencil}
                        onClick={() => {
                          setEdited(() => {
                            onShowEditUser()
                            return user
                          })
                        }}
                      />
                      <Button className="me-2" variant="tertiary" onClick={handleDelete(user)} icon={BsTrash} />
                    </td>
                  </tr>
                ))
              }
              </tbody>
            </table>
          </div>
        </div>
        {/* modals */}
        <NewUser show={showNewUser} onHide={hideNewUser} />
        {edited && <EditUser userData={edited} show={showEditUser} onHide={hideEditUser} />}
        <UserRoles show={show} onHide={onHide} />
      </Container>
    </div>
  )
}

export default AdminUserPage
